import * as React from 'react';
import { useTopBarCount } from '../../hooks/topBar';

export const TotalCountContainer = () => {
  const topBarCount = useTopBarCount();

  return <React.Fragment>{topBarCount.text}</React.Fragment>;
};
